import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ParametrosService } from 'app/services/parametros.service';
import { ProductoService } from 'app/services/producto.service';

@Component({
  selector: 'app-confirmar-caja',
  templateUrl: './confirmar-caja.component.html',
  styleUrls: ['./confirmar-caja.component.css']
})
export class ConfirmarCajaComponent implements OnInit {

  verMensaje: boolean;
  verPagoEfectivo: boolean;
  verSpinner: boolean;
  verPagoOtraF: boolean;
  activarBtnGuardar: boolean;
  total;
  mpagos = [];
  bancos = [];
  lstMedioPagoSelected = [];
  form: UntypedFormGroup;
  montorecibido: string;
  cambio = '0.00';
  fpago = 'Efectivo';
  paymentMethods: any[] = [];
  selectedPaymentMethod: any = null;
  transferNumber = '';
  chequeNumber = '';
  issuingBank = '';
  cardLast4 = '';
  sumaPagos: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ConfirmarCajaComponent>,
    private snackBar: MatSnackBar,
    private fb: UntypedFormBuilder,
    private parametroService: ParametrosService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.form = this.fb.group({
        montorecibido: new UntypedFormControl(''),
        paymentMethod: new UntypedFormControl(3, []), // Por defecto efectivo (code 3)
        transferNumber: new UntypedFormControl(''),
        chequeNumber: new UntypedFormControl(''),
        issuingBank: new UntypedFormControl(''),
        cardLast4: new UntypedFormControl('')
      });
      this.total =  Number.parseFloat(this.data.total).toFixed(2);
     }

  ngOnInit(): void {
    this.obtenerMediosDePagos();
    this.obtenerBancos();
    this.activarBtnGuardar = true;
    this.verPagoEfectivo = true;
    this.verPagoOtraF = false;
    this.parametroService.getMediosPagos().subscribe((data: any) => {
      this.paymentMethods = data;
      this.form.get('paymentMethod')?.valueChanges.subscribe((value) => {
        const id = typeof value === 'string' ? parseInt(value, 10) : value;
        this.selectedPaymentMethod = this.paymentMethods.find(m => m.id === id);
        this.updateAdditionalFields();
      });
    });
  }

  obtenerMediosDePagos() {
    this.verSpinner = true; 
    this.parametroService.getMediosPagos().subscribe(
      (data) => {
        this.mpagos = data;
        this.selectedPaymentMethod = this.mpagos.find(m => m.code === '3'); // Efectivo por defecto
        this.form.get('paymentMethod')?.setValue(this.selectedPaymentMethod.id);
      },
      (err) => console.log(err),
      () => (this.verSpinner = false)
    );
  }

  obtenerBancos() {
    this.parametroService.getBancos().subscribe(
      (data) => {
        this.bancos = data;
      },
      (err) => console.log(err)
    );
  }

  verFPago() {}

  updateAdditionalFields() {
    // Limpiar validadores
    this.form.get('transferNumber')?.clearValidators();
    this.form.get('chequeNumber')?.clearValidators();
    this.form.get('issuingBank')?.clearValidators();
    this.form.get('cardLast4')?.clearValidators();
    // Limpiar valores
    this.form.get('transferNumber')?.setValue('');
    this.form.get('chequeNumber')?.setValue('');
    this.form.get('issuingBank')?.setValue('');
    this.form.get('cardLast4')?.setValue('');
    // Validar según método de pago
    if (!this.selectedPaymentMethod) return;
    
    // Manejar el código como string o number
    const code = String(this.selectedPaymentMethod.code);
    
    switch (code) {
      case '4': // Transferencia
        this.form.get('transferNumber')?.setValidators([c => c.value ? null : { required: true }]);
        this.form.get('issuingBank')?.setValidators([c => c.value ? null : { required: true }]);
        this.form.get('montorecibido')?.setValidators([c => c.value ? null : { required: true }]);
        break;
      case '5': // Cheque
        this.form.get('chequeNumber')?.setValidators([c => c.value ? null : { required: true }]);
        this.form.get('issuingBank')?.setValidators([c => c.value ? null : { required: true }]);
        break;
      case '1': // Tarjeta Débito
      case '2': // Tarjeta Crédito
        this.form.get('cardLast4')?.setValidators([c => c.value && c.value.length === 4 ? null : { required: true }]);
        break;
      case '3': // Efectivo
      default:
        // No validaciones extra
        break;
    }
    this.form.get('transferNumber')?.updateValueAndValidity();
    this.form.get('chequeNumber')?.updateValueAndValidity();
    this.form.get('issuingBank')?.updateValueAndValidity();
    this.form.get('cardLast4')?.updateValueAndValidity();
  }


  guardarCaja() {
    // Devolver un objeto consistente que tenga todos los formatos posibles para compatibilidad
    this.dialogRef.close({
      cambio: this.cambio,
      montoing: this.sumaPagos,
      total: this.total,
      transferNumber: this.form.value.transferNumber,
      chequeNumber: this.form.value.chequeNumber,
      issuingBank: this.form.value.issuingBank,
      cardLast4: this.form.value.cardLast4,
      paymentMethod: this.form.value.paymentMethod,
      montorecibido: this. getMontorecibido(),
      formaPago: this.selectedPaymentMethod,
    });
  }

  getMontorecibido() {  
    // Si el medio de pago es efectivo, retorna el monto recibido menos el total
    if (this.form.controls.paymentMethod.value === 3) {
      const recibido = parseFloat(this.form.controls.montorecibido.value) || 0;
      const total = parseFloat(this.total) || 0;
      // si el monto recibido es mayor al total, retorna el monto total
      if (recibido >= total) {
        return total;
      }
      // si el monto recibido es menor al total, retorna el monto recibido
      return recibido;
    } else {
      // Si no es efectivo, retorna el monto recibido
      const recibido = parseFloat(this.form.controls.montorecibido.value) || 0;
      return recibido;
    }
  }


  calcularCambio(e: any) {
    if (this.form.controls.paymentMethod.value === 3) {
      this.montorecibido = this.form.controls.montorecibido.value;
      let recibido = Number.parseFloat(this.montorecibido);
      let total = Number.parseFloat(this.total);
      let diferencia = recibido - total;
      if (!isNaN(recibido) && recibido > 0 && recibido >= total) {
        this.cambio = diferencia > 0 ? diferencia.toFixed(2) : '0.00';
        this.activarBtnGuardar = false;
      } else {
        this.cambio = '0.00';
        this.activarBtnGuardar = true;
      }
    } 
    
  }

  cancelar() {
    this.dialogRef.close();
  }
}
